import React from 'react'
import styled from 'styled-components'
import cn from 'clsx'
import { rem } from 'polished'
import Caption from 'components/Luxkit/Typography/Caption'
import eases from 'styles/tools/eases'
import Clickable from './Clickable'

const Container = styled(Clickable)`
  background-color: ${({ theme }) => theme.palette.neutral.four};
  height: ${rem(24)};
  width: ${rem(48)};
  border-radius: ${props => props.theme.borderRadius.round};
  transition: background-color 0.3s ease;

  &.toggled {
    background-color: ${({ theme }) => theme.palette.messaging.success.main};
  }
`

const Circle = styled.div`
  background-color: ${({ theme }) => theme.palette.neutral.eight};
  box-shadow: ${({ theme }) => theme.shadow.flat.small};
  transform: translate3d(0, 0, 0);
  height: ${rem(24)};
  width: ${rem(24)};
  border-radius: ${props => props.theme.borderRadius.round};
  border: 1px solid ${({ theme }) => theme.palette.neutral.five};
  transition: transform .35s ${eases.iosBounce.inOut};
  &.toggled {
    transform: translate3d(100%, 0, 0);
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: ${rem(12)}
  }
`

interface Props {
  toggled?: boolean;
  onToggle?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
  className?: string;
}

function SwitchButton(props: Props) {
  const { toggled, onToggle, label, className } = props

  return (
    <Wrapper role="switch" aria-checked={toggled} className={className} >
      {!!label && <Caption variant="large" as="label">{label}</Caption>}
      <Container as={onToggle ? Clickable : 'div'} onClick={onToggle} className={cn({ toggled })} >
        <Circle aria-hidden="true" className={cn({ toggled })} />
      </Container>
    </Wrapper>
  )
}

export default SwitchButton
